import { memo, useCallback, useState } from 'react';
// @mui
import Collapse from '@mui/material/Collapse';
import List from '@mui/material/List';
import Stack from '@mui/material/Stack';
//
import { useAuthContext } from 'src/auth/hooks';
import { USER_TYPE } from 'src/types/ApiConstant';
import { NavConfigProps, NavListProps, NavSectionProps } from '../types';
import { StyledSubheader } from './styles';

import { navVerticalConfig } from '../config';
import NavList from './nav-list';

// ----------------------------------------------------------------------

function NavSectionVertical({ data, config, sx, ...other }: NavSectionProps) {
  const { user } = useAuthContext();

  return (
    <Stack sx={sx} {...other}>
      {data.map((group, index) => {
        const condition =
          (!group.forReader && USER_TYPE.SYSTEM_USER === user?.type) ||
          (group.forReader && USER_TYPE.READER === user?.type);
        return condition ? (
          <Group
            key={group.subheader || index}
            subheader={group.subheader}
            childrenRules={group.childrenRules}
            items={group.items}
            config={navVerticalConfig(config)}
          />
        ) : null;
      })}
    </Stack>
  );
}

export default memo(NavSectionVertical);

// ----------------------------------------------------------------------

type GroupProps = {
  subheader: string;
  childrenRules?: string[];
  items: NavListProps[];
  config: NavConfigProps;
};

function Group({ subheader, childrenRules, items, config }: GroupProps) {
  const [open, setOpen] = useState(true);

  const handleToggle = useCallback(() => {
    setOpen((prev) => !prev);
  }, []);

  if (childrenRules && !childrenRules.some((r) => config?.currentRules?.includes(r))) {
    return null;
  }

  const renderContent = items.map((list) => {
    return (
      <NavList
        key={list.title + list.path}
        data={list}
        depth={1}
        hasChild={!!list.children}
        config={config}
      />
    );
  });

  return (
    <List disablePadding sx={{ px: 2 }}>
      {subheader ? (
        <>
          <StyledSubheader disableGutters disableSticky onClick={handleToggle} config={config}>
            {subheader}
          </StyledSubheader>
          <Collapse in={open}>{renderContent}</Collapse>
        </>
      ) : (
        renderContent
      )}
    </List>
  );
}
